import { useState, useEffect } from 'react';

/**
 * FIX L-10: Shared timer for relative timestamps.
 * Instead of each ConversationItem creating its own 60s setInterval,
 * this hook uses a single global interval shared across all subscribers.
 */
let globalTick = 0;
const listeners = new Set();
let intervalId = null;

function startTicker() {
    if (intervalId) return;
    intervalId = setInterval(() => {
        globalTick++;
        listeners.forEach(fn => fn(globalTick));
    }, 60000);
}

function stopTicker() {
    if (listeners.size === 0 && intervalId) {
        clearInterval(intervalId);
        intervalId = null;
    }
}

export function useTimeTick() {
    const [tick, setTick] = useState(globalTick);
    useEffect(() => {
        listeners.add(setTick);
        startTicker();
        return () => {
            listeners.delete(setTick);
            stopTicker();
        };
    }, []);
    return tick;
}
